import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { HousingInfo as ViewComponent } from '../../../../components/HousingInfo/HousingInfo';
import { PageHeader } from '../../../../components/shared/PageHeader/PageHeader';
import { TABS } from '../constants';

export const HousingView = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <PageHeader
        breadCrumbs={['Account']}
        navigate={navigate}
        selectedTab="Housing"
        tabs={TABS}
        tabsSiblingRouteDepth="../"
        title="Account"
      />
      <ViewComponent />
    </Fragment>
  );
};
